import { render, staticRenderFns } from "./JsonBox.vue?vue&type=template&id=858ecb74&"
import script from "./JsonBox.vue?vue&type=script&lang=js&"
export * from "./JsonBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports